/**
 * @fileoverview 404 Not Found page component for ISCRI Dashboard
 * @author ISCRI Team
 */

import { Link } from "react-router-dom";
import { ROUTES } from "@router";
import "./NotFound.css";

/**
 * 404 Not Found page component with navigation back to main areas
 * Provides helpful links and maintains ISCRI branding
 */
const NotFound = () => {
  return (
    <div className="not-found">
      <div className="not-found__container">
        {/* Error Code */}
        <div className="not-found__code">
          <span className="not-found__number">404</span>
          <div className="not-found__animation">
            <div className="globe"></div>
            <div className="orbit orbit-1"></div>
            <div className="orbit orbit-2"></div>
          </div>
        </div>

        {/* Content */}
        <div className="not-found__content">
          <h1 className="not-found__title">Page Not Found</h1>

          <p className="not-found__description">
            The page you're looking for seems to have disappeared into the
            geopolitical void. Don't worry, diplomatic relations are still being
            tracked!
          </p>

          {/* Navigation Options */}
          <div className="not-found__actions">
            <Link to={ROUTES.HOME} className="button button-primary">
              Return to Home
            </Link>
            <Link to={ROUTES.SIMPLE} className="button button-outline">
              Explore ISCRI Data
            </Link>
          </div>

          {/* Quick Links */}
          <div className="not-found__links">
            <h3>Quick Navigation</h3>
            <div className="not-found__nav-grid">
              <Link to={ROUTES.HOME} className="nav-card">
                <div className="nav-card__icon">🏠</div>
                <div className="nav-card__title">Home</div>
                <div className="nav-card__desc">ISCRI Overview</div>
              </Link>

              <Link to={ROUTES.SIMPLE} className="nav-card">
                <div className="nav-card__icon">📊</div>
                <div className="nav-card__title">Simple Explorer</div>
                <div className="nav-card__desc">Analyze Country Relations</div>
              </Link>

              <Link to={ROUTES.ABOUT} className="nav-card">
                <div className="nav-card__icon">ℹ️</div>
                <div className="nav-card__title">About</div>
                <div className="nav-card__desc">Learn About SKEMA</div>
              </Link>

              <Link to={ROUTES.METHODOLOGY} className="nav-card">
                <div className="nav-card__icon">📚</div>
                <div className="nav-card__title">Methodology</div>
                <div className="nav-card__desc">Research & Papers</div>
              </Link>
            </div>
          </div>

          {/* Support Info */}
          <div className="not-found__support">
            <p className="support-text">
              Having trouble finding what you need?
              <a
                href="mailto:rodolphe.desbordes@skema.edu"
                className="support-link"
              >
                Contact our team
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;